import Http from "../strategies/Http";
import Beacon from "../strategies/Beacon";
export default function Hiido(options, initialData) {
  var beacon = new Beacon(options, initialData);
  var http = new Http(options, initialData);
  var universal = {
    httpInstance: http,
    beaconInstance: beacon
  };
  if (Beacon.supported) {
    return Object.assign(beacon, universal);
  }
  if (Http.supported) {
    return Object.assign(http, universal);
  }
}